import React, { useEffect, useState } from "react";
import { useFormikContext } from "formik";
import { Card } from "react-bootstrap";
import {
  FormSelectField,
  FormTextField,
} from "../../../../../partials/content/Forms/FormField";
import { getCustomerMasterDataAPI } from "../../../../../services/sales/customerService";
import MapPlaces from "../../../../../partials/content/MapPlaces";
import DialogLayout from "../../../../../partials/content/DialogLayout";
function QuotationAddress({
  customerAddresses = [],
  customerAddressDefault = false,
  handleCustomerAddressDefault,
}) {
  const { values, setFieldValue } = useFormikContext();
  const [addressOptions, setAddressOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [openSearchMapPlaces, setOpenSearchMapPlaces] = useState(false);
  useEffect(() => {
    function getCustomerMasterData() {
      getCustomerMasterDataAPI().then((response) => {
        const { data, auth } = response.data;
        const { countries } = data;
        setAddressData(customerAddresses, countries);
      });
    }
    getCustomerMasterData();
  }, [customerAddresses]);
  return (
    <React.Fragment>
      <Card>
        <Card.Header>
          <i className="fas fa-map-marked-alt"></i>
          <span>
            {values.customerType === 2 ? (
              <strong>Customer Address</strong>
            ) : (
              <strong>Lead Address</strong>
            )}
          </span>
        </Card.Header>
        <Card.Body>
          <div className="row">
            {values.customerType === 2 ||
            typeof values.customerType === "undefined" ? (
              <div className="col-sm-12 col-md-12 col-lg-12">
                <FormSelectField
                  label="Address Name Reference"
                  name="addressName"
                  options={addressOptions}
                  onSelectChange={(addressValue) => {
                    setFieldValue("addressName", addressValue);
                    setFieldValue("address", addressValue.address);
                    setFieldValue("city", addressValue.city);
                    setFieldValue("province", addressValue.province);
                    setFieldValue("countryCode", addressValue.countryCode);
                    setFieldValue("postalCode", addressValue.postalCode);
                    setFieldValue("addressPhone", addressValue.addressPhone);
                    setFieldValue("addressEmail", addressValue.addressEmail);
                  }}
                />
              </div>
            ) : null}
            <div className="col-sm-6 col-md-6 col-lg-6">
              <FormTextField
                label="Address"
                name="address"
                mapsButton
                onMapsClick={() => {
                  setOpenSearchMapPlaces(true);
                }}
              />
              <FormTextField label="City" name="city" />
              <FormTextField label="Province / State" name="province" />
            </div>
            <div className="col-sm-6 col-md-6 col-lg-6">
              <FormTextField label="Phone Number" name="addressPhone" />
              <FormTextField label="Email" name="addressEmail" />
              <FormTextField label="Postal Code" name="postalCode" />
            </div>
            <div className="col-sm-12 col-md-12 col-lg-12">
              <FormSelectField
                label="Country"
                name="countryCode"
                options={countryOptions}
              />
            </div>
          </div>
        </Card.Body>
      </Card>
      <DialogLayout
        open={openSearchMapPlaces}
        title="Search Address on Maps"
        onCloseDialog={() => {
          setOpenSearchMapPlaces(false);
        }}
        maxWIdth="lg"
        minHeight={true}
      >
        <MapPlaces
          address={values.address}
          city={values.city}
          province={values.province}
          countryCode={values.countryCode}
          postalCode={values.postalCode}
          onPinLocation={(
            selectedFormattedAddress,
            selectedShortAddressComponents,
            selectedLongAddressComponents,
            selectedAddress,
            selectedCity,
            selectedProvince,
            selectedCountryCode,
            selectedPostalCode
          ) => {
            setFieldValue(`address`, selectedAddress);
            setFieldValue(`city`, selectedCity);
            setFieldValue(`province`, selectedProvince);
            setFieldValue(`countryCode`, selectedCountryCode);
            setFieldValue(`postalCode`, selectedPostalCode);
            setOpenSearchMapPlaces(false);
          }}
          onCloseDialog={() => {
            setOpenSearchMapPlaces(false);
          }}
        />
      </DialogLayout>
    </React.Fragment>
  );
  function setAddressData(customerAddresses = [], countries = []) {
    let addressOptionsTmp = [];
    let countryOptionsTmp = [];
    addressOptionsTmp.push({
      value: {
        addressName: {},
        address: "",
        city: "",
        province: "",
        countryCode: "",
        postalCode: "",
        addressPhone: "",
        addressEmail: "",
      },
      label: "No Reference",
    });
    if (typeof countries !== "undefined") {
      countries.forEach((country) => {
        countryOptionsTmp.push({
          value: country.countryCode,
          label: country.countryName,
        });
      });
    }
    if (typeof customerAddresses !== "undefined") {
      customerAddresses.map((customerAddress, index) => {
        addressOptionsTmp.push({
          value: customerAddress,
          label: customerAddress.addressName,
        });
        if (
          customerAddress.addressName === "Main Address" &&
          customerAddressDefault === true &&
          values.ID === 0
        ) {
          setFieldValue("addressName", customerAddress);
          setFieldValue("address", customerAddress.address);
          setFieldValue("city", customerAddress.city);
          setFieldValue("province", customerAddress.province);
          setFieldValue("countryCode", customerAddress.countryCode);
          setFieldValue("postalCode", customerAddress.postalCode);
          setFieldValue("addressPhone", customerAddress.addressPhone);
          setFieldValue("addressEmail", customerAddress.addressEmail);
          handleCustomerAddressDefault();
        }
      });
    }
    setAddressOptions(addressOptionsTmp);
    setCountryOptions(countryOptionsTmp);
  }
}

export default QuotationAddress;
